import React from 'react';
import { render } from 'react-dom';
import Root from './root';

render(
    <Root/>,
    document.getElementById('root')
)

if (module.hot && process.env.NODE_ENV !== 'production') {
    module.hot.accept();
}



// WEBPACK FOOTER //
// ./src/index.js